interface PendingTwoFactorChallenge {
  challengeToken: string
  remember: boolean
}

let pending: PendingTwoFactorChallenge | undefined

/**
 * Transient, in-memory handoff for the 5-minute `challenge_token` (and the
 * "remember me" choice from step 1) between `/auth/login` and
 * `/two-factor-challenge`. Never persisted to a cookie or Web Storage --
 * a persisted copy of a single-use credential is the exact cross-site-cookie
 * problem this fix removes, just renamed.
 */
export const pendingTwoFactorChallenge = {
  set(challengeToken: string, remember: boolean): void {
    pending = { challengeToken, remember }
  },
  peek(): PendingTwoFactorChallenge | undefined {
    return pending
  },
  clear(): void {
    pending = undefined
  }
}
